<script>
    import { onMount } from "svelte";
    import Cinema from "../components/Cinema.svelte";
    import { withResolvers } from "@otto-ec/assets-core-utils/promise";
    import { renderComplementaryRecommendationsInternal } from "../services/nexusInternal/internalNexusEvents.js";
    import { getFeatureOrder } from "../utils/externalTrackingHelper.js";

    let { data } = $props();

    let cinemaInjectionContainerWidth = $state(1000);
    let featureIndex = $state("99");

    let trackingEventMergeId = $state(null);
    let refreshingDomClass = $state("");
    let cinemaContainer;
    const [cinemaContainerMounted, mountSuccess] = withResolvers();

    onMount(() => {
        featureIndex = getFeatureOrder(cinemaContainer);
        cinemaInjectionContainerWidth = cinemaContainer.offsetWidth || 1000;

        return renderComplementaryRecommendationsInternal?.sub(
            async (detail) => {
                trackingEventMergeId = detail?.eventMergeId;
                mountSuccess();
            },
            { once: true }
        );
    });
</script>

<div bind:this={cinemaContainer}>
    {#if data}
        <div class="reco_complementary_cinema_wrapper{refreshingDomClass}">
            <Cinema
                headline={data.headline}
                recommendations={data.recommendations}
                tracking={data.tracking}
                {featureIndex}
                additionalClickTracking={data.additionalClickTracking}
                featuresState={data.featuresState}
                {cinemaInjectionContainerWidth}
                cinemaMeta={data.metaData}
                {trackingEventMergeId}
                loadedTrackingActionName="change"
                site="RecoDetailViewComplementary"
                personalisedUser={data.hasPersonalisedRecommendations || false}
                {cinemaContainerMounted}
            />
        </div>
    {/if}
</div>

<style lang="scss">
    .reco_complementary_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;

        &__loading {
            pointer-events: none;
            opacity: 0.5;
        }
    }
</style>
